import React from 'react';

export default function SettingsButtonGradient() {
  return (
    <svg
      width="0"
      height="0"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      style={{ position: 'absolute', width: 0, height: 0 }}
      viewBox="0 0 125 120"
      fill="none"
      aria-hidden={true}
    >
      <defs>
        <linearGradient
          id="svgBtnStroke"
          gradientUnits="objectBoundingBox"
          x1="0"
          y1="0"
          x2="0"
          y2="1"
        >
          <stop offset="0%" stopColor="#ffeb8e" />
          <stop offset="20%" stopColor="#ffeb8e" />
          <stop offset="50%" stopColor="#ffeb8e" />
          <stop offset="80%" stopColor="#d5bb43" />
          <stop offset="100%" stopColor="#ffeb8e" />
        </linearGradient>
      </defs>
    </svg>
  );
}
